import { findFirst } from '../../../../../../services/arrays';
import Unibar from '../../input-fields/unibar';

const unibars: Unibar[] = [];

export function getUnibar(id: string): Unibar {
    const result = findFirst(unibars, bar => bar.id === id);
    if (!result) throw new Error(`Unibar ${id} was not found!`);
    return result;
}

export function createUnibar(el: Element): void {
    const id = el.id;
    if (!id) {
        console.warn('Unibar', el, 'has no ID so could not be created');
        return;
    }

    unibars.push(new Unibar(id));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/input-fields/unibar/unibar-storage.ts